/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../store';

interface ISectionProps {
  settings: any;
  components: { [key: string]: FunctionComponent<any> };
}

const Section: React.FunctionComponent<ISectionProps> = ({
  settings,
  components,
}) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState, getParagraphState } = useStore();
  const [completedKeys, setCompletedKeys] = useState<string[]>([]);
  const getCompletedKey = (itm: any, index: number) =>
    `${
      itm.target
        ? `${index}--${itm.target}`
        : itm.className
        ? `${index}--${itm.className.split(' ')[0]}`
        : ''
    }`;
  const onCompleted = (completedKey: string) => {
    console.log('onCompleted - completedKey', completedKey);
    setCompletedKeys((o_completedKeys) => [...o_completedKeys, completedKey]);
  };
  useEffect(() => {
    const animationComponentsKeys = settings.items
      .map((itm: any, idx: number) => ({
        ...itm,
        completedKey: getCompletedKey(itm, idx),
      }))
      .filter(
        (itm: any) =>
          itm.component.indexOf('Animation') !== -1 || itm.component === 'Quiz'
      )
      .map((itm: any) => itm.completedKey);
    if (
      !animationComponentsKeys.some(
        (key: string) => !completedKeys.includes(key)
      ) &&
      settings.id !== 'landing'
    ) {
      updateParagraphState(p_course, p_topic, settings.id, 'completed', []);
    } else {
      const p_component: any[] = [];
      animationComponentsKeys.forEach((key: any) => {
        if (!completedKeys.includes(key)) {
          p_component.push(key);
        }
      });
      const paragraphState = getParagraphState(p_course, p_topic).find(
        (itm) => itm.id === settings.id
      );
      updateParagraphState(
        p_course,
        p_topic,
        settings.id,
        paragraphState ? paragraphState.state : 'not-start',
        p_component
      );
    }
  }, [completedKeys]);
  return (
    <>
      {settings.items?.map((itm: any, index: number) => {
        const Component = components[itm.component] as FunctionComponent<any>;
        const completedKey = getCompletedKey(itm, index);
        return (
          <Component
            key={completedKey}
            {...itm}
            onCompleted={() => onCompleted(completedKey)}
          />
        );
      })}
    </>
  );
};
export default Section;
